<section class="report grid-y align-middle">
  <div *ngIf="systemReports?.length" class="known-issues">
    <div class="title">
      <fa-icon class="icon" [icon]="['fas', 'info-circle']"> </fa-icon>
      Known Issues
    </div>

    <div class="issues">
      <div *ngFor="let issue of systemReports" class="issue-card">
        <div class="issue-card__body">
          <div class="mb-2 flex gap-2 align-middle">
            <div class="issue-card__date">
              {{ issue.updatedat | date: 'MMMM dd, yyyy - hh:mm' }} UTC
            </div>
          </div>
          <div class="issue-card__title">{{ issue.title }}</div>
          <p class="issue-card__content">
            {{ issue.message }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <!-- COMMENTS -->
  <div class="cell">
    <label for="report-issue-comments" class="label">Describe issue<span class="required">*</span></label>
    <textarea id="report-issue-comments"
      class="comment"
      [formControl]="comments"
      maxlength="4000"
      rows="8"
    ></textarea>
  </div>

  <!-- BUTTONS -->
  <div class="actions">
    <cpd-stroked-button
      color="primary"
      text="Cancel"
      size="large"
      mat-dialog-close
    ></cpd-stroked-button>
    <cpd-flat-button
      color="primary"
      [disabled]="comments.invalid"
      text="Submit"
      size="large"
      type="submit"
      (click)="reportIssue()"
    ></cpd-flat-button>
  </div>
</section>
